import { render } from "./ClubDealBuyChatModal.vue?vue&type=template&id=01ac024b&scoped=true&ts=true"
import script from "./ClubDealBuyChatModal.vue?vue&type=script&lang=ts"
export * from "./ClubDealBuyChatModal.vue?vue&type=script&lang=ts"

import "./ClubDealBuyChatModal.vue?vue&type=style&index=0&id=01ac024b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ac024b"]])

export default __exports__